<template>
	<div class="save-cancel">
		<SubmitButton :label="saveLabel" :invalid="invalid" :busy="busy" />
		<button v-if="!hideCancel" type="button" class="cancel" @click="cancel" :disabled="busy">
			{{ cancelLabel }}
		</button>
	</div>
</template>

<script>
import SubmitButton from '@/components/SubmitButton'

export default {
	name: 'SaveCancel',
	props: {
		saveLabel: {
			type: String,
			default: 'Save',
		},
		cancelLabel: {
			type: String,
			default: 'Cancel',
		},
		hideCancel: Boolean,
		invalid: Boolean,
		busy: Boolean,
	},
	methods: {
		cancel() {
			this.$emit('cancel')
		},
	},
	components: {
		SubmitButton,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.save-cancel {
	.cancel {
		@include button--large($black, $white, $black, $grey-90);
	}

	@include not-last {
		margin-right: 1rem;
	}

	@include mq-max(md) {
		.cancel {
			width: 100%;
		}

		@include not-last {
			margin-right: 0;
			margin-bottom: 1rem;
		}
	}
}
</style>
